import { businessPlanAxios } from 'services/controllers/businessPlan';

import * as t from './types';

export const RevenuePlanApi = {
  getCalculationsOnProductUpdate: async (params: t.IUpdateProductCalculationsParams) => {
    const { id, businessPlanId, product, unit, otherIncome } = params;
    const { data } = await businessPlanAxios.put<t.IRevenuePlanCalculationResponse>(
      `/${businessPlanId}/product/${id}/update/revenueplan/${unit}`,
      { productsData: product, otherIncomeData: otherIncome },
    );
    return data;
  },
  getAllProductsCalculations: async (params: t.IGetAllProductsCalculationsParams) => {
    const { businessPlanId, unit, otherIncome } = params;
    const { data } = await businessPlanAxios.post<t.IRevenuePlanCalculationResponse>(
      `/${businessPlanId}/product/revenueplan/${unit}`,
      otherIncome,
    );
    return data;
  },
};
